/**
 * Runtime environment configuration loaded from window.__env
 * This allows dynamic environment variables to be injected at container runtime
 */

// Extend the Window interface to include __env
declare global {
  interface Window {
    __env?: {
      production?: boolean;
      api_url?: string;
      noti_api_url?: string;
      noti_ws_url?: string;
      rest_api_url?: string;
      theme?: string;
      s3_url?: string;
      styler_s3_url?: string;
      gtp_url?: string;
      fr_url?: string;
      show_storefront_link?: boolean;
      styler_url_host?: string;
      styler_url_b2c?: string;
      styler_url_b2b?: string;
      styler_api_url?: string;
      pdf_api_url?: string;
      logo_src?: string;
    };
  }
}

/**
 * Get runtime environment configuration
 * Falls back to empty object if not available or not in browser
 */
export function getRuntimeConfig() {
  // Check if we're in a browser environment (for SSR compatibility)
  if (typeof window !== 'undefined' && window.__env) {
    return window.__env;
  }
  return {};
}

/**
 * Check if runtime config is available
 */
export function hasRuntimeConfig(): boolean {
  return typeof window !== 'undefined' && !!window.__env;
}
